/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=0d738e30"
const script = {}

import exportComponent from "C:\\Users\\zyark\\Desktop\\ems-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__